import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './shared/components/toast/toast.component';
import { environment } from '../environments/environment';

/**
 * Root application component.
 *
 * Serves as the entry point for the Angular application.
 * Contains only a router outlet to delegate rendering to child routes.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent],
  template: '<router-outlet /><app-toast />',
  host: { '[class.non-prod]': '!isProd' },
  styles: `
    :host {
      display: block;
    }
    :host.non-prod {
      border: 4px solid var(--color-error);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class App {
  protected readonly isProd = environment.production;
}
